import Product from "./models/Product";

const targetVersion = 7;

export class AppConfig {
  orderFields: {
    agreementKeyId: string;
    clientNameId: string;
    clientSsnId: string;
    clientAddressId: string;
    clientCredibilityId: string;
    clientZipCodeId: string;
    clientCityId: string;
    portedPhoneId: string;
    contactPhoneId: string;
  };

  demo?: boolean;

  version: number;

  products: Product[];
  
  defaultProductId: Product["id"];
};

export const defaultConfig: AppConfig = {
  "orderFields": {
    "agreementKeyId": "68ad6520a40978f6cd83f39a",
    "clientSsnId": "68a5f9f00d2c96e86ad1c97b",
    "clientNameId": "68ab074a61ace60003cae38a",
    "clientCredibilityId": "68ad6571a40978f6cd83f3bb",
    "clientAddressId": "68a5f9f00d2c96e86ad1c978",
    "clientZipCodeId": "68a5f9f00d2c96e86ad1c979",
    "clientCityId": "68a5f9f00d2c96e86ad1c97a",
    "contactPhoneId": "68a5f9f00d2c96e86ad1c97c",
    "portedPhoneId": "68ad6509a40978f6cd83f37c"
  },
  "version": targetVersion,

  "products": [
  ],
  "defaultProductId": "69a462b2ba2bd93653878101"
};

type CompanyConfig = {
  company: string;
  companyShort: string;
  email: string;
  website: string;
  agreementWebsite: string;
  logoSrc: string;
  resourcesDirectory: string;
  themeColor: string;
};

export const companyConfig: CompanyConfig = {
  company: 'Fjällkraft',
  companyShort: 'Fjällkraft',
  email: 'support@fjallkraft.se',
  website: 'https://fjallkraft.se/',
  agreementWebsite: 'https://avtal.fjallkraft.se',
  logoSrc: require('./logos/fjallkraft_logo.png').default,
  resourcesDirectory: 'fjallkraft',
  themeColor: '#3373F4'
};